<div class="customer-header__customer-info flex flex-row gap-x-4">
  <div class="flex flex-col">
    <h4>{{ customerName }} - {{ customerNumber }}</h4>
  </div>
  @if (customerType) {
    <img
      [src]="customerType | icon: true"
      [ngClass]="{
        'outline cursor-pointer outline-ssGold1 outline-offset-2 rounded-full ':
          makeIconClickable,
      }"
      (click)="makeIconClickable && customerTypeClicked()"
      alt="Customer Type"
    />
  }
</div>

@if (accountFrozen) {
  <span class="customer-header__customer-info__frozen-flag text-xl font-bold"
    >Frozen</span
  >
}
